module.exports = {
	"id": "SA",
	"name": "Saudi Arabia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.007538,
			"12": 0.003769,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.003769,
			"19": 0.184681,
			"20": 0.007538,
			"21": 0.003769,
			"22": 0.011307,
			"23": 0.003769,
			"24": 0.572888,
			"25": 0.007538,
			"26": 0.007538,
			"27": 0.011307,
			"28": 0.011307,
			"29": 0.022614,
			"30": 0.199757,
			"31": 0.090456,
			"32": 0.007538,
			"33": 0.090456,
			"34": 0.018845,
			"35": 0.384438,
			"36": 0.015076,
			"37": 0.011307,
			"38": 0.026383,
			"39": 0.033921,
			"40": 0.018845,
			"41": 0.015076,
			"42": 0.018845,
			"43": 0.48997,
			"44": 0.030152,
			"45": 0.041459,
			"46": 0.033921,
			"47": 0.060304,
			"48": 0.056535,
			"49": 0.874408,
			"50": 0.079149,
			"51": 0.482432,
			"52": 0.305289,
			"53": 15.211684,
			"54": 4.149669,
			"55": 0.109301,
			"56": 0.030152,
			"57": null
		},
		"firefox": {
			"2": 0.180912,
			"3": 0.018845,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.003769,
			"13": null,
			"14": null,
			"15": 0.180912,
			"16": null,
			"17": null,
			"18": 0.184681,
			"19": null,
			"20": null,
			"21": 0.192219,
			"22": 0.007538,
			"23": 0.192219,
			"24": null,
			"25": 0.384438,
			"26": 0.007538,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.007538,
			"31": 0.003769,
			"32": null,
			"33": 0.007538,
			"34": 0.003769,
			"35": 0.007538,
			"36": 0.018845,
			"37": 0.007538,
			"38": 0.015076,
			"39": 0.015076,
			"40": 0.011307,
			"41": 0.011307,
			"42": 0.011307,
			"43": 0.07538,
			"44": 0.03769,
			"45": 0.056535,
			"46": 0.048997,
			"47": 0.260061,
			"48": 0.222371,
			"49": 2.201096,
			"50": 0.094225,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.003769
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.011307,
			"36": 0.007538,
			"37": 0.011307,
			"38": 0.033921,
			"39": 0.011307,
			"40": 0.026383,
			"41": 0.003769,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.192219,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.003769
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.180912,
			"6": 0.007538,
			"7": 0.030152,
			"8": 0.124377,
			"9": 0.11307,
			"10": 0.606809,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03769,
			"6.1": 0.015076,
			"7.1": 0.011307,
			"9.1": 0.437204
		},
		"ios_saf": {
			"8": 0,
			"10": 9.71860288093,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.261905101998,
			"8.1-8.4": 0.483858578268,
			"9.0-9.2": 0.230831615321,
			"9.3": 3.52166182348
		},
		"android": {
			"3": 0,
			"4": 0.0660347803618,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00825434754522,
			"4.1": 0.238196886305,
			"4.2-4.3": 0.595492215762,
			"4.4": 1.36550492248,
			"4.4.3-4.4.4": 1.37729684755
		},
		"ie": {
			"6": 0.0075936538146,
			"7": 0.0037968269073,
			"8": 0.725193939295,
			"9": 0.694819324036,
			"10": 0.592304997539,
			"11": 2.60462325841,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00601492191729,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000167081164369
		},
		"edge": {
			"12": 0.071611,
			"13": 0.290213,
			"14": 0.508815
		},
		"ie_mob": {
			"10": 0.0233405633803,
			"11": 0.0950294366197
		},
		"bb": {
			"7": 0.0389375,
			"10": null
		},
		"samsung": {
			"0": 4.4233
		},
		"and_uc": {
			"0": 14.64673
		},
		"op_mini": {
			"0": 0.0810379969183
		},
		"and_chr": {
			"0": 25.522526
		},
		"and_ff": {
			"0": 0.03115
		}
	},
	"total": 98.3190025
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SA.json
 ** module id = 637
 ** module chunks = 0
 **/